import { Toaster } from "react-hot-toast";
import UtilitiesConfigCard from "../../../components/card/UtilitiesConfigCard";
import ViewLogsConfigCard from "../../../components/card/ViewLogsConfigCard";
import QueryConfigCard from "../../../components/card/QueryConfigCard";
import GateBarrierConfigurationsCard from "../../../components/card/GateBarrierConfigurationsCard";

const InternalConfig = () => {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="flex flex-col gap-4 md:gap-8">
        <h1 className="text-xl md:text-2xl dark:text-white">
          Internal Configurations
        </h1>

        <GateBarrierConfigurationsCard />
        <UtilitiesConfigCard />
        <ViewLogsConfigCard />
        <QueryConfigCard />
      </div>
    </>
  );
};

export default InternalConfig;
